module.exports = __webpack_public_path__ + "static/img/card.4c36c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_design/card.png
// module id = 164
// module chunks = 1